module.exports = "<div><ng-content></ng-content></div>"